// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_downloads_ui_styles" + "." + "1736c91c" + ".chunk.css";
};